import React from "react";
import FieldProto from "../../../../../proto/field-proto";

type Props = {
    className?  : string
    field       : FieldProto
    disabled?   : boolean
    onClick     : callback
    children    : any
}

export default function FieldViewForUser_ControlViewEmpty(props: Props) {

    const classes = Classes("ui5-control-button s-28", props.className, {
        "disabled"                      : props.disabled
    })

    return (
        <>
            <div className={classes} onClick={props.onClick}>

                <div className="i5-user icon m-r-5"></div>
                <div className="ui5-txt-not-important-small lh-13em">
                    View for
                </div>

                <div className="btn-arrow flex-row-center-center w-16 m-l-5"></div>

            </div>
            {props.children}
        </>
    )
}
